import React from 'react';
import GroupSessionsView from 'components/session/GroupSessionsView';

// Admin: ve TODAS las sesiones grupales (sin scope de entrenador). Layout two-pane.
function GroupSessionsPage() {
  return <GroupSessionsView trainerScoped={false} />;
}

export default GroupSessionsPage;
